// Shared GrowthBook client. Lives outside App.jsx so non-React callers
// (utils/everflow, which runs at boot) can await the same init without pulling
// the whole app in — utils/paywall imports utils/everflow, so an import back
// into App.jsx would risk a cycle.
//
// Moved here from App.jsx unchanged: same options, same attribute layering,
// same init. App.jsx now imports the instance instead of constructing one.

import { GrowthBook } from '@growthbook/growthbook';
import { autoAttributesPlugin } from '@growthbook/growthbook/plugins';

export const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GB_API,
  clientKey: process.env.REACT_APP_GB_KEY,
  enableDevMode: process.env.NODE_ENV === 'development',
  trackingCallback: (experiment, result) => {
    console.log('Viewed Experiment', {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
  plugins: [autoAttributesPlugin()],
});

// Resolves once features are loaded. Callers needing a deadline must race this
// themselves — do NOT pass `timeout` to init(): the SDK only subscribes to
// late-arriving feature data when streaming is on, so a timed-out init would
// leave the app with an empty payload for the whole page load.
export const gbReady = growthbook.init({ streaming: false }).then(() => {
  const params = new URLSearchParams(window.location.search);
  const urlAttrs = {};
  for (const [key, value] of params.entries()) urlAttrs[key] = value;
  if (Object.keys(urlAttrs).length > 0) {
    growthbook.setAttributes({
      ...growthbook.getAttributes(),
      ...urlAttrs,
    });
  }
});
